import React, { useState } from 'react';
import { InformationCircleIcon } from '@heroicons/react/24/outline';

export default function Tooltip({ children, content, position = 'top' }) {
  const [isVisible, setIsVisible] = useState(false);

  const positionClasses = {
    top: 'bottom-full left-1/2 transform -translate-x-1/2 mb-2',
    bottom: 'top-full left-1/2 transform -translate-x-1/2 mt-2',
    left: 'right-full top-1/2 transform -translate-y-1/2 mr-2',
    right: 'left-full top-1/2 transform -translate-y-1/2 ml-2'
  };

  const arrowClasses = {
    top: 'top-full left-1/2 transform -translate-x-1/2 border-t-gray-800 border-t-4 border-l-transparent border-r-transparent border-l-4 border-r-4',
    bottom: 'bottom-full left-1/2 transform -translate-x-1/2 border-b-gray-800 border-b-4 border-l-transparent border-r-transparent border-l-4 border-r-4',
    left: 'left-full top-1/2 transform -translate-y-1/2 border-l-gray-800 border-l-4 border-t-transparent border-b-transparent border-t-4 border-b-4',
    right: 'right-full top-1/2 transform -translate-y-1/2 border-r-gray-800 border-r-4 border-t-transparent border-b-transparent border-t-4 border-b-4'
  };

  return (
    <div className="relative inline-block">
      <div
        onMouseEnter={() => setIsVisible(true)}
        onMouseLeave={() => setIsVisible(false)}
        className="cursor-help"
      >
        {children}
      </div>
      
      {isVisible && (
        <div className={`absolute z-50 ${positionClasses[position]}`}>
          <div className="bg-gray-800 text-white text-sm rounded-lg px-3 py-2 max-w-xs shadow-lg">
            {content}
          </div>
          <div className={`absolute w-0 h-0 ${arrowClasses[position]}`}></div>
        </div>
      )}
    </div>
  );
}

// Helper component for settings labels with tooltips
export function SettingTooltip({ label, tooltip, position = 'right' }) {
  return (
    <div className="flex items-center">
      <span className="text-sm font-medium text-gray-700">{label}</span>
      <Tooltip content={tooltip} position={position}>
        <InformationCircleIcon className="w-4 h-4 ml-1.5 text-gray-400 hover:text-gray-600 transition-colors" />
      </Tooltip>
    </div>
  );
}